export default __webpack_public_path__ + "static/media/ennovate_6.ff04fecf.jpg";